import { ActionHandler } from "..";
import { getURLParams } from "src/utils/urlParams";
import { getInAppAutoCookie } from "src/utils/authCookieParser";
import { getUpsellAdDataQuery } from "src/api/healthReportUpsell";
import { UpsellAdData, UpsellAdLocation } from "gql/graphql";
import {
  setUpsellAdData,
  setUpsellAdDataLoading,
} from "src/utils/redux/slices/upsellAdData";

let pendingUpsellAdDataPromise: ReturnType<typeof getUpsellAdDataQuery> | null =
  null;

export const loadUpsellAdData: ActionHandler = ({ store }) => {
  const { ad_location: adLocation } = getURLParams();
  const accessCode = getInAppAutoCookie()?.accessCode;
  if (!accessCode || !adLocation || pendingUpsellAdDataPromise) return;

  store.dispatch(setUpsellAdDataLoading(true));

  pendingUpsellAdDataPromise = getUpsellAdDataQuery(
    accessCode,
    adLocation as UpsellAdLocation
  )
    .then((response) => {
      const data = response.data.upsellAdDataList.upsellAdData;

      if (data?.length)
        store.dispatch(
          setUpsellAdData({
            loading: false,
            healthReportUpsell: data[0] as UpsellAdData,
          })
        );

      return response;
    })
    .finally(() => {
      store.dispatch(setUpsellAdDataLoading(false));
      pendingUpsellAdDataPromise = null;
    });
};

export const waitForUpsellAdData: ActionHandler = async () => {
  if (pendingUpsellAdDataPromise) await pendingUpsellAdDataPromise;
};
